import React from "react";
import * as RelationUtils from "utils/relation";
import { ConditionInput } from "components/UnifiedProject/SelectData/ConditionListInput";
import styles from "components/Tiles/Sense/style.module.css";
const FilterRelationInput = ({ relation, onChange, isDisabled }) => {
    const handleChange = (filter) => onChange(RelationUtils.builder(relation.input).filter(filter).build());
    return (React.createElement("div", { style: { marginBottom: "20px", fontSize: "12px" } },
        React.createElement("div", { className: styles.relationItemSubHeader }, "Would you like to focus on specific rows?"),
        React.createElement("div", { className: styles.relationItemSubHeader, style: { marginBottom: "10px" } }, "Specify the criteria that will be used to determine which rows of data to include."),
        React.createElement(ConditionInput, { condition: relation.filter, onChange: handleChange, context: RelationUtils.getOutputContext(relation.input), isDisabled: isDisabled })));
};
export default FilterRelationInput;
